import type { ControlPosition, IControl } from "maplibre-gl";
import type { Map } from "~/ui/map";

import { addTooltip, controlButton, controlContainer } from "~/utils";

import { TruckRestrictionsLayer } from "../layers";

export class TruckRestrictionsControl implements IControl {
    private map: Map;
    private container: HTMLElement;
    private ctrlButton: HTMLElement;

    onAdd(map: Map): HTMLElement {
        this.map = map;
        const instance = this.map.addLayerInstance(TruckRestrictionsLayer);
        this.container = controlContainer();
        this.ctrlButton = this.container.appendChild(controlButton({
            title: TruckRestrictionsLayer.title,
            className: "nmapsgl-ctrl-truck-restrictions",
            onClick: this.onCtrlClick
        }));
        addTooltip(this.ctrlButton);

        if (instance.isEnabled()) this.ctrlButton.classList.add("active");
        instance.on("show", this.onShow);
        instance.on("hide", this.onHide);
        return this.container;
    }

    onRemove(): void {
        const instance = this.map.getLayerInstance(TruckRestrictionsLayer.id);
        instance.off("show", this.onShow);
        instance.off("hide", this.onHide);
        delete this.map;
    }

    getDefaultPosition?: () => ControlPosition = () => "top-right";

    private onCtrlClick = () => {
        const instance = this.map.getLayerInstance(TruckRestrictionsLayer.id);
        instance.setState(!instance.isEnabled());
    };

    private onShow = () => {
        this.ctrlButton.classList.add("active");
    };

    private onHide = () => {
        this.ctrlButton.classList.remove("active");
    };
}